import * as React from 'react';

import { SrsMonacoEditor } from 'src/containers/MonacoEditor/SrsMonacoEditor';

type ProjectRuleTextEditorProps = {
  textValue: string;
  setTextValue: (value: string) => void;
};

const UnmemoizedProjectRuleTextEditor: React.VFC<
  ProjectRuleTextEditorProps
> = ({ textValue, setTextValue }) => {
  return (
    <div className="sd-project-rule-text-editor">
      <SrsMonacoEditor setValue={setTextValue} value={textValue} />
    </div>
  );
};

export const ProjectRuleTextEditor = React.memo<ProjectRuleTextEditorProps>(
  UnmemoizedProjectRuleTextEditor,
  () => true
);
